import { render, staticRenderFns } from "./org-selector.vue?vue&type=template&id=4ea78d2a&scoped=true"
import script from "./org-selector.vue?vue&type=script&lang=js"
export * from "./org-selector.vue?vue&type=script&lang=js"
import style0 from "./org-selector.vue?vue&type=style&index=0&id=4ea78d2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea78d2a",
  null
  
)

export default component.exports